module.exports = __webpack_public_path__ + "img/sign_240750780_1.f87efdb3.png";